import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StaticService } from 'src/static.service';
import { ResponseModel, ResetEmailModel } from '../model/auth.model';
import { ResetModel } from '../reset-password/reset-password.component';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  constructor(
    private http: HttpClient,
    private staticService: StaticService,
    private handler: HttpBackend
  ) {
    this.http = new HttpClient(handler);
  }

  login(email: string, password: string) {
    return this.http.post<ResponseModel>(this.staticService.auth.login, {
      email,
      password,
    });
  }

  logout(refresh: string) {
    return this.http.post<ResponseModel>(this.staticService.auth.logout, {
      refresh: refresh,
    });
  }

  refresh(refresh: string) {
    return this.http.post<ResponseModel>(this.staticService.auth.logout, {
      refresh: refresh,
    });
  }

  forgetPassword(email: string): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(this.staticService.auth.forgotPassword, {
      email: email,
    });
  }

  reset(reset: ResetModel): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(
      this.staticService.auth.reset + reset.uid + `&token=` + reset.token,
      {
        new_password: reset.new_password,
        confirm_password: reset.confirm_password,
      }
    );
  }

  resetEmail(resetEmail: ResetEmailModel): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(this.staticService.auth.resetEmail, {
      uid: resetEmail.uid,
      token: resetEmail.token,
      data: resetEmail.data,
    });
  }
}
